module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/woman_holding_phone@2x-a67ac5acda6edc0d5b4d526d13ceaadd.webp";